import { getIsLoggedIn } from '../../publicSession/selectors';

export const getDuperRedirectThreshold = state => {
  return 3;
};

export const isBannerVisible = state => {
  return !getIsLoggedIn(state);
};
